import React from 'react';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import Select from '../../_Shared/SearchableDropdown';

const _ = require('lodash');

class BudgetLineSettings extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            budgetLine: this.props.budgetLine
        }
    }
    
    static defaultProps = {
        websites: []
    }

    componentDidUpdate(prevProps) {
        const { budgetLine } = this.props;
        if (!_.isEqual(prevProps.budgetLine, budgetLine)) {
            this.setState({ budgetLine });
        }
    }

    website = () => {
        const { websites } = this.props;
        const { budgetLine } = this.state;

        if (budgetLine.websiteId) {
            let website = websites.find(x => x.id === budgetLine.websiteId);
            if (website) { return website; }
        }

        return { purchaseModels: [], formats: [] };
    }

    render() {
        const { handleInputChange, campaign, websites } = this.props;
        const { budgetLine } = this.state;
        const selectedWebsite = this.website();
        return (
            <Grid item xs={3}>
                <Grid container item spacing={24}>
                    <Grid item xs>
                    {
                        campaign && campaign.layers &&
                        <Select options={[].concat(campaign.layers).map(x => { return { 'label': x.name, 'value': x.id } })}
                            value={budgetLine.layerId} name="layerId" label="Layer" onChange={value => handleInputChange('layerId', value)}
                            placeholder={"Please select a Layer"} />
                    }
                    </Grid>
                </Grid>
                <Grid container item spacing={24}>
                    <Grid item xs>
                    {
                        websites &&
                        <Select options={[].concat(websites).map(x => { return { 'label': x.name, 'value': x.id } })}
                            value={budgetLine.websiteId} name="websiteId" label="Website" onChange={value => handleInputChange('websiteId', value)}
                            placeholder={"Please select a Website"} />
                    }
                    </Grid>
                </Grid>
                <Grid container item spacing={24}>
                    <Grid item xs>
                    {
                        selectedWebsite && selectedWebsite.purchaseModels &&
                        <Select options={selectedWebsite.purchaseModels.map(x => { return { 'label': x.name, 'value': x.id } })}
                            disabled={!budgetLine.websiteId} value={budgetLine.purchaseModelId} name="purchaseModelId"
                            label="Purchase Model" onChange={value => handleInputChange('purchaseModelId', value)}
                            placeholder={!budgetLine.websiteId ? "Select Website First" : "Please select a Purchase Model"} />
                    }
                    </Grid>
                </Grid>
                <Grid container item spacing={24}>
                    <Grid item xs>
                    {
                        selectedWebsite && selectedWebsite.formats &&
                        <Select options={selectedWebsite.formats.map(x => { return { 'label': x, 'value': x } })}
                            disabled={!budgetLine.websiteId} value={budgetLine.format} name="format" label="Format"
                            onChange={value => handleInputChange('format', value)}
                            placeholder={!budgetLine.websiteId ? "Select Website First" : "Please select a Format"} />
                    }
                    </Grid>
                </Grid>
                <Grid container item spacing={24}>
                    <Grid item xs>
                        <TextField autoFocus value={budgetLine.details} onChange={e => handleInputChange('details', e.target.value)}
                            id="details" name="details" label="Details" type="text" fullWidth />
                    </Grid>
                </Grid>
                <Grid container item spacing={24}>
                    <Grid item lg={6}>
                        <Select options={[{ label: "CPM", value: "cpm" }, { label: "CPC", value: "cpc" }, { label: "CPV", value: "cpv" }, { label: "Fixed", value: "fixed" }]}
                            value={budgetLine.buyType} name="buyType" label="Buy Type" onChange={value => handleInputChange('buyType', value)} placeholder={"Please select a Buy Type"} />
                    </Grid>
                    <Grid item lg={6}>
                        <TextField value={budgetLine.costModifier} onChange={e => handleInputChange('costModifier', e.target.value)}
                            id="costModifier" name="costModifier" label="Cost Modifier" type="number" InputProps={{
                                endAdornment: <InputAdornment position="end" >%</InputAdornment>
                            }} />
                    </Grid>
                </Grid>
                <Grid container item spacing={24}>
                    <Grid item xs>
                        <TextField multiline rows={5} value={budgetLine.comments} onChange={e => handleInputChange('comments', e.target.value)}
                            id="comments" name="comments" label="Comments" type="text" fullWidth />
                    </Grid>
                </Grid>  
            </Grid>
        )
    }
}

export default BudgetLineSettings;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Campaigns/MediaPlan/BudgetLineSettings.js